import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';

function CollectionsMenu() {

    const [showButton, setShowButton] = useState(true);
    const [showMenu, setShowMenu] = useState(false);

    return (
        <div>
            {showButton &&
                <div className="collections-tab" id="collectionsToggle" onClick={() => { setShowButton(false); setShowMenu(true) }}><span>Collections</span></div>
            }
            {showMenu &&
                <div>
                    <aside className="collections-panel">
                        <div className="collections-panel-header">
                            <h2>Collections</h2>
                            <div className="collections-close" onClick={() => { setShowButton(true); setShowMenu(false) }}>&times;</div>
                        </div>
                        <nav className="collections-nav">
                            <Link to="/ExecutiveOrders.html">Executive Orders</Link>
                            <Link to="/Senate2026.html">Senate Races 2026</Link>
                            <Link to="/House2026.html">House Races 2026</Link>
                            <Link to="/Governors2026.html">Gubernatorial Races 2026</Link>
                        </nav>
                    </aside>
                    <div className="collections-overlay"></div>
                </div>
            }
        </div>
    )
}

export default CollectionsMenu
